import AncillaryDescriptionMybUIModel from '../../cms-wrapper/ancillary-description-myb';
import asyncActionTypes from '../actions/types.js';

const initialState = {
  ancillaries: null,
  ancillaryMybDescriptions: {},
  errorAncillaryMybCms: null,
  loadingAncillaryMybCollection: false,
  showUpgradeCP: false,
};

const ancillaryMyb = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.RETRIEVE_CMS_ANCILLARY_MYB.START:
      return {
        ...state,
        loadingAncillaryMybCollection: true,
      };
    case asyncActionTypes.RETRIEVE_CMS_ANCILLARY_MYB.SUCCESS:
      const ancillaryDescriptions = action.payload.ancillaries;
      const ancillaryDescriptionsByType = {};
      let upgradeCP = false;

      for (let i = 0; i < ancillaryDescriptions.length; i++) {
        ancillaryDescriptionsByType[ancillaryDescriptions[i].ancillary.Type] =
        new AncillaryDescriptionMybUIModel(ancillaryDescriptions[i].ancillary);
      }

      action.payload.ancillaries.forEach(ancillary => {
        if (ancillary && ancillary.ancillary && ancillary.ancillary.Type === 'UPG') {
          upgradeCP = ancillary.ancillary.showPayCP === 'true';
        }
      });

      return {
        ...state,
        ancillaries: ancillaryDescriptions,
        ancillaryMybDescriptions: { ...ancillaryDescriptionsByType },
        errorAncillaryMybCms: null,
        loadingAncillaryMybCollection: false,
        showUpgradeCP: upgradeCP,
      };
    case asyncActionTypes.RETRIEVE_CMS_ANCILLARY_MYB.FAIL:
      return {
        ...state,
        loadingAncillaryMybCollection: false,
        errorAncillaryMybCms: action.error,
        ancillaryMybDescriptions: {},
      };
    default:
      return state;
  }
};

export default ancillaryMyb;